/** @file Emits slot records in setup draw order: bone index, blend code, colors, setup placeholder. */
import { isSlotPermutation } from '@pose2d/format/doc/isSlotPermutation';
import { throwError } from '@pose2d/format/throwError';
import type { Doc, Pose2DJson } from '@pose2d/format/types';
import { COMPILE_CODES } from './compileCodes';
import { requireCompiledIndex } from './requireCompiledIndex';

/** Slots in `doc.drawOrder` order and the id -> index map; VALIDATION when drawOrder is not a permutation. */
export function compileSlots(doc: Doc, boneIndex: ReadonlyMap<string, number>): { slots: Pose2DJson['slots']; slotIndex: Map<string, number> } {
  if (!isSlotPermutation(doc, doc.drawOrder)) throwError('VALIDATION', undefined, { path: 'drawOrder', hint: 'drawOrder must list every slot exactly once' });
  const slots: Pose2DJson['slots'] = [];
  const slotIndex = new Map<string, number>();
  for (const id of doc.drawOrder) {
    const slot = doc.slots[id];
    if (slot === undefined) continue; // unreachable after isSlotPermutation; narrows the type
    slotIndex.set(id, slots.length);
    slots.push({
      name: slot.name,
      bone: requireCompiledIndex(boneIndex, slot.bone, 'bone', `slots.${id}.bone`),
      attachment: slot.setup.attachment,
      blend: COMPILE_CODES.blend[slot.blend],
      color: slot.setup.color,
      ...(slot.setup.dark === null ? {} : { dark: slot.setup.dark }),
    });
  }
  return { slots, slotIndex };
}
